import { Modal } from "antd"
import { useTranslation } from "react-i18next"
import PrimaryButton from "../button/PrimaryButton"
import SecondaryButton from "../button/SecondaryButton"
import style from "./Modal.module.css";

const ModalTrip = ({ visible, title, message, onClick, action, type })=>{
  const {t} = useTranslation()
return(
  <>
      <Modal
        visible={visible}
        closable={false}
        centered={true}
        width="464px"
        footer={null}
      >
        <div className={style.ModalTitle}>{ title }</div>
        <div className={style.ModalSubTitle}>
          {message}
          <br />
        </div>

        <div
          style={{
            justifyItems: "center",
            margin: 0,
            padding: 0,
            display: "flex",
          }}
        >
          <div className="mr-8 ml-9">
            <SecondaryButton
              text={t("USER_DETAIL:CANCEL")}
              action={() => onClick()}
            />
          </div>

          <PrimaryButton
            text={t("Yes, " + type)}
            action={() => action()}
          />
        </div>
      </Modal>
  </>
)
}

export default ModalTrip